import ActionButton from './ActionButton'

const SelectionOptions = ({ handleClick }) => {
  return (
    <div className={'transaction-action-list'}>
      {/*<ActionLink value={'LINK_EXCHANGE'} label={'Link Exchange'} handleClick={handleClick} />*/}
      {/*<ActionLink value={'IMPORT_CSV'} label={'Import CSV'} handleClick={handleClick} />*/}
      {/*//TODO: When api is ready comment out disabled*/}
      <ActionButton
        value="ADD_TRANSACTION"
        handleClick={handleClick}
        disabled
        title="Coming soon"
      >
        Add Transaction
      </ActionButton>
      {/*<ActionButton*/}
      {/*  value={'ADD_JOURNAL_ENTRY'}*/}
      {/*  label={'Manual Add Journal Entry'}*/}
      {/*  handleClick={handleClick}*/}
      {/*/>*/}
      {/*<ActionButton*/}
      {/*  value={'UPLOAD_CSV'}*/}
      {/*  label={'Upload Transactions'}*/}
      {/*  handleClick={handleClick}*/}
      {/*/>*/}
    </div>
  )
}

export default SelectionOptions
